import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash, FaCommentDots, FaUserPlus, FaPhoneAlt } from 'react-icons/fa';
import { useDispatch } from "react-redux";
import { successToast, errorToast, warningToast, infoToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import Search from "../../common/Search";
import { getUserRole } from "../../Utils/role";
import Pagination from '../../common/Pagination';
import Swal from "sweetalert2";
import { assignLeadStore, } from "../../redux/services/AssignTask Services/AssignTask.Services";
import { useSelector } from "react-redux";
import { getNewLeadList, updateLeadStatus, deleteLead } from "../../redux/services/leadServices/Lead.Services"
import { startAiCall } from "../../redux/services/Ai Services/Ai.Services"
function NewLead() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const leadRefresh = useSelector((state) => state.refresh.lead);
    const role = getUserRole();
    const isAdmin = role === "admin";
    const [leadData, setLeadData] = useState([]);
    const [initialLoading, setInitialLoading] = useState(true);
    const [aiCallLoading, setAiCallLoading] = useState(false);
    const [tableLoading, setTableLoading] = useState(false);
    const [limit, setLimit] = useState(100);
    const [totalLeads, setTotalLeads] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");
    const [filteredLeads, setFilteredLeads] = useState([]);
    const [activeFilter, setActiveFilter] = useState("all");
    const [page, setPage] = useState(1);
    const [showFilter, setShowFilter] = useState(false);
    const [counts, setCounts] = useState({
        all: 0,
    });
    const [filters, setFilters] = useState({
        status: "",
        source: "",
        customer_name: "",
        mobile: "",
        search: "",
        from_date: "",
        to_date: ""
    });
    const [selectedLeadIds, setSelectedLeadIds] = useState([]);
    const [assignLoading, setAssignLoading] = useState(false);
    const handleDelete = async (id) => {
        try {
            const res = await deleteLead({
                id: id,
            });
            successToast(res?.message);
            const updatedLeads = leadData.filter(item => item.id !== id);
            setLeadData(updatedLeads);
            setFilteredLeads(updatedLeads);
            setSelectedLeadIds(prev => prev.filter(leadId => leadId !== id));
        } catch (error) {
            errorToast(
                error?.response?.data?.message ||
                error?.message ||
                "Delete failed"
            );
        }
    };
    const handleAssignClick = () => {
        if (selectedLeadIds.length === 0) {
            return Swal.fire({
                title: "No Selection",
                text: "Please select at least one lead to assign",
                icon: "warning",
                confirmButtonText: "OK",
            });
        }
        dispatch(
            openModal({
                type: "assign-leads",
                title: "Assign Selected Leads",
                data: {
                    leadIds: selectedLeadIds,
                    onAssign: assignSelectedLeads,
                    isLoading: assignLoading,
                },
            })
        );
    };

    const getSelectedLeads = () => {
        return leadData.filter((lead) =>
            selectedLeadIds.includes(lead.id)
        );
    };
    const getVendorId = (lead) => {
        return (
            lead?.vendor_id ||
            lead?.vendor?.id ||
            lead?.vendor?.vendor_id ||
            null
        );
    };
    const handleAiCalling = async () => {
        const selectedLeads = getSelectedLeads();
        if (!selectedLeads.length) {
            return errorToast("Please select at least one lead");
        }
        try {
            setAiCallLoading(true);
            const vendorId = getVendorId(selectedLeads[0]);
            for (const lead of selectedLeads) {
                const payload = {
                    vendor_id: String(vendorId),

                    leads: selectedLeads.map((lead) => ({
                        lead_id: lead.id,
                        phone: lead.mobile,
                    })),
                };
                const response = await startAiCall(payload);
                if (response?.popup_type === "call_in_progress") {
                    infoToast(response?.popup_message);

                } else if (response?.popup_type === "busy") {
                    warningToast(response?.popup_message);

                } else if (response?.status === "success") {
                    successToast(response?.popup_message || response?.message);

                } else {
                    errorToast(response?.message || "Something went wrong.");
                }

            }
        }
        catch (error) {
            console.error("AI Calling Error:", error);

            errorToast(
                error?.response?.data?.popup_alert?.message ||
                error?.response?.data?.message ||
                error?.message ||
                "AI calling failed"
            );
        } finally {
            setAiCallLoading(false);
        }
    };

    const handleWhatsappMessage = async () => {
        const selectedLeads = getSelectedLeads();
        if (!selectedLeads.length) {
            return errorToast("Please select at least one lead");
        }
        const payload = selectedLeads.map((lead) => ({
            lead_id: lead.id,
            vendor_id: getVendorId(lead),
            phone: lead.mobile,
        }));
        console.log("WhatsApp Payload:", payload);
    };

    const assignSelectedLeads = async (userId) => {
        if (!userId) {
            return errorToast("Please select a staff member");
        }
        try {
            setAssignLoading(true);
            const payload = {
                user_id: userId,
                task_ids: selectedLeadIds,
            };
            const response = await assignLeadStore(payload);

            if (response?.status === true || response?.success === true) {
                setLeadData(prev =>
                    prev.filter(lead => !selectedLeadIds.includes(lead.id))
                );
                setFilteredLeads(prev =>
                    prev.filter(lead => !selectedLeadIds.includes(lead.id))
                );
                setSelectedLeadIds([]);
                successToast(response?.message || "Leads assigned successfully 🚀");
                await fetchLeads(page);
            } else {
                errorToast(response?.message || "Assignment failed");
            }
        } catch (error) {
            console.error("Assignment Error:", error);
            errorToast(error?.response?.data?.message || "Assignment failed");
        } finally {
            setAssignLoading(false);
        }
    };

    const handleBulkAction = (action) => {
        switch (action) {
            case "ai_calling":
                handleAiCalling();
                break;

            case "whatsapp_message":
                handleWhatsappMessage();
                break;

            default:
                break;
        }
    };

    const toggleLeadSelection = (id) => {
        setSelectedLeadIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };
    const handleStatusUpdate = async (data) => {
        try {
            await updateLeadStatus(data);
            Swal.fire({
                icon: "success",
                title: "Status Updated",
                text: "Lead status successfully updated!",
                timer: 1500,
                showConfirmButton: false
            });
            await fetchLeads(page);

        } catch (error) {
            console.log(error);
            errorToast("Status update failed");
        }
    };

    // useEffect(() => {
    //     fetchLeads();
    // }, []);

    useEffect(() => {
        fetchLeads(1, true);
    }, [search]);

    useEffect(() => {
        if (leadRefresh > 0) {
            fetchLeads(page);
        }
    }, [leadRefresh]);

    const fetchLeads = async (pageNo = 1, isInitialLoad = false) => {
        try {
            if (isInitialLoad) {
                setInitialLoading(true);
            } else {
                setTableLoading(true);
            }
            const payload = {
                page: pageNo,
                per_page: limit,
                search:search
            };
            const response = await getNewLeadList(payload);
            const leads = (response?.data || []).filter(
                (lead) => lead.status === "New"
            );
            setPage(response?.current_page || 1);
            setTotalPages(response?.last_page || 1);
            setTotalLeads(response?.total || 0);
            setLeadData(leads);
            setFilteredLeads(leads);
            setCounts({
                all: response?.total || 0,
            });

            setSelectedLeadIds([]);

        } catch (error) {
            console.log(error);
            errorToast("Failed to fetch leads");
        } finally {
            setInitialLoading(false);
            setTableLoading(false);
        }
    };
    const tabs = [
        {
            label: `New Leads (${counts.all})`,
            className: "btn-all",
            value: "all",
        },
    ];
    const handleFilterClick = (filter) => {
        setActiveFilter(filter);

        if (filter === "all") {
            setFilteredLeads(leadData);
        }
    };
    const handlePageChange = (newPage) => {
        if (
            newPage >= 1 &&
            newPage <= totalPages &&
            !tableLoading
        ) {
            setPage(newPage);
            fetchLeads(newPage, false);
        }
    };
    const handleToggleFilter = () => {
        setShowFilter(!showFilter);
    };
    const refreshLeads = () => {
        fetchLeads(page);
    };
    // if (initialLoading) {
    //     return (
    //         <div className="text-center py-5">
    //             <div className="spinner-border text-primary"></div>
    //         </div>
    //     );
    // }
    return (
        <div>
            <div className="d-flex align-items-center justify-content-between  page-header-breadcrumb">
                <div className="title_member">
                    <h4>New Leads</h4>
                    <nav className="page-breadcrumb">
                        <Link to="/">Home</Link>
                        <span className="mx-2">/</span>
                        <span>New Leads</span>
                    </nav>
                </div>
                <div className="d-flex flex-wrap gap-2 justify-content-end">

                    {selectedLeadIds.length > 0 && (
                        <select
                            className="form-select"
                            style={{ width: "200px" }}
                            defaultValue=""
                            onChange={(e) => {
                                handleBulkAction(e.target.value);
                                e.target.value = "";
                            }}
                        >
                            <option value="">Select Action</option>

                            <option value="ai_calling">
                                AI Calling
                            </option>

                            <option value="whatsapp_message">
                                WhatsApp Message
                            </option>
                        </select>
                    )}

                    {selectedLeadIds.length > 0 && (
                        <button
                            className="lead-btn btn-import"
                            onClick={handleAssignClick}
                            disabled={assignLoading}
                        >
                            <FaUserPlus className="me-1" />
                            Assign Selected ({selectedLeadIds.length})
                        </button>
                    )}
                    {/* <button
                            className="btn btn-primary btn-sm"
                            onClick={handleToggleFilter}
                        >
                            <i className="fas fa-filter me-1"></i>
                            {showFilter ? "Hide Filter" : "Filter"}
                        </button> */}
                    {tabs.map((tab, index) => (
                        <button
                            key={index}
                            className={`lead-btn btn-all ${tab.className} ${activeFilter === tab.value ? "active" : ""
                                }`}
                            onClick={() => handleFilterClick(tab.value)}
                        >
                            {tab.label}
                        </button>
                    ))}
                    <button
                        onClick={() => navigate("/add-lead")}
                        className="lead-btn btn-add"
                    >
                        Add Lead
                    </button>
                    <button
                        className="lead-btn btn-import"
                        onClick={() =>
                            dispatch(
                                openModal({
                                    type: "import-lead",
                                    title: "Import Leads",
                                    // data: {
                                    //     onSuccess: refreshLeads,
                                    // },
                                })
                            )
                        }
                    >
                        Import Lead
                    </button>
                </div>
            </div>
            <div className="main_page">
             {(totalLeads > 0 || search) && (
    <div className="d-flex justify-content-end align-items-center gap-2 mx-2 mb-2">
        <Search
            search={search}
            placeholder="Search Lead..."
            onSearch={(value) => {
                setSearch(value);
                setPage(1);
            }}
        />
        {totalPages > 1 && (
            <Pagination
                page={page}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        )}
    </div>
)}
                <div className="st-wrapper-card text-center">
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    {/* <th>Select</th> */}
                                    <th>Sr.No.</th>
                                    <th>Lead Id</th>
                                    <th> Name</th>
                                    <th> Mobile No</th>
                                    <th> Vendor Name</th>
                                    <th> Source</th>
                                    {/* <th> Assigned By</th>
                                {role === "admin" && <th>Assigned To</th>} */}
                                    {/* <th>Assigned Info</th>
                              {role === "admin"&& <th>Status</th>}
                             
                               
                                <th>Remark</th> */}
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tableLoading ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-5">
                                                <div className="spinner-border text-primary"></div>
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredLeads?.map((item, index) => (
                                            <tr key={item.id}>
                                                {/* <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedLeadIds.includes(item.id)}
                                                        onChange={() => toggleLeadSelection(item.id)}
                                                    />
                                                </td> */}
                                                <td>{(page - 1) * limit + index + 1}</td>
                                                <td>{item.lead_id}</td>
                                                <td className="fw-semibold" style={{ whiteSpace: "nowrap" }}> {item?.name} </td>
                                                <td>{item.mobile}</td>
                                                <td>{item?.vendor_details?.name}</td>

                                                <td>
                                                    <span
                                                        className={`source-badge ${item.source === "Website"
                                                            ? "website"
                                                            : item.source === "Facebook"
                                                                ? "facebook"
                                                                : item.source === "Justdial"
                                                                    ? "instagram"
                                                                    : item.source === "IndiaMART"
                                                                        ? "indiamart"
                                                                        : ""
                                                            }`}
                                                    >
                                                        {item.source}
                                                    </span>
                                                </td>


                                                {/* <td>{item.assign_by?.name}</td>
                                    {role === "admin" && (
                                        <td>{item.assign_to?.name}</td>
                                    )} */}
                                                {/* <td>
  <div className="d-flex align-items-center gap-2">
    <span className="whitedesign text-primary fw-semibold">
      By: {item.assign_by?.name || "-"}
    </span>

    <span>|</span>

    <span className="whitedesign text-success fw-semibold">
      To: {item.assign_to?.name || "-"}
    </span>
  </div>
</td>
    {role === "admin" && (
                                    <td className="fw-semibold">
                                        {item.status}
                                    </td>
    )}
                                    <td>
                                        <div className="remark-cell">
                                            {item.remarks}
                                        </div>
                                    </td> */}
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-center gap-1">
                                                        <button
                                                            className="st-action-btn st-view-btn"
                                                            onClick={() => navigate(`/view-lead/${item.id}`)}
                                                        >
                                                            <FaEye />
                                                        </button>


                                                        <button
                                                            className="st-action-btn st-edit-btn"
                                                            // onClick={() => {
                                                            //     dispatch(
                                                            //         openModal({
                                                            //             type: "update-status",
                                                            //             title: "Update Lead Status",
                                                            //             data: {
                                                            //                 id: item.id,
                                                            //                 status: item.status,
                                                            //                 statusOptions: STATUS_OPTIONS,
                                                            //                 role,
                                                            //                 onSubmit: updateLeadStatus,
                                                            //                 onSuccess: () => {
                                                            //                     fetchLeads();
                                                            //                 },
                                                            //             },
                                                            //         })
                                                            //     );
                                                            // }}
                                                            onClick={() => navigate(`/update-lead/${item.id}`)}
                                                        >
                                                            <FaEdit />
                                                        </button>

                                                        <button
                                                            className="st-action-btn st-view-btn"
                                                            title="Call History"
                                                            onClick={() =>
                                                                navigate(`/view-call-detail/${item.mobile}`)
                                                            }
                                                        >
                                                            <FaPhoneAlt />
                                                        </button>
                                                        {role === "admin" && (
                                                            <button
                                                                className="st-action-btn st-delete-btn"
                                                                onClick={() =>
                                                                    dispatch(
                                                                        openModal({
                                                                            type: "delete-lead",
                                                                            title: "Delete Lead",
                                                                            data: {
                                                                                id: item.id,
                                                                                deleteFunction: deleteLead,
                                                                                refreshData: () => fetchLeads(page),
                                                                            },
                                                                        })
                                                                    )
                                                                }
                                                            >
                                                                <FaTrash />
                                                            </button>
                                                        )}

                                                        <button
                                                            className="st-action-btn st-view-btn"
                                                            onClick={() => navigate(`/remark-history/${item.id}`)}
                                                        >
                                                            <FaCommentDots />
                                                        </button>
                                                    </div>

                                                </td>
                                            </tr>
                                        ))
                                    )}
                                {!tableLoading && filteredLeads.length === 0 && (
                                    <tr>
                                        <td colSpan="7" className="text-center py-4">
                                            <div className="text-muted">
                                                No leads found
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {totalPages > 1 && (
                            <div className='d-flex justify-content-end'>
                                <Pagination
                                    page={page}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
export default NewLead;